module.exports = __webpack_public_path__ + "static/media/WorkExperiencePreparationEmploymentSkills.ddc97b62.pdf";